import { render, staticRenderFns } from "./PaymentDetailsTable.vue?vue&type=template&id=467c476c&"
import script from "./PaymentDetailsTable.vue?vue&type=script&lang=js&"
export * from "./PaymentDetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports